import { Component, Input, Host, OnInit } from '@angular/core';
//import { GridOptions, ColDef, AllModules } from '@ag-grid-enterprise/all-modules';
import { GridOptions, ColDef, GridApi } from 'ag-grid-community';

import { Organization } from '../../../../../common/models/organization.model';
import { RouterLinkRendererComponent } from '../../../../../common/components/ag-grid/router-link-renderer.component';
import { Observable } from 'rxjs';
import { ChiefsOrdersActionsComponent } from './chiefs-orders-actions/chiefs-orders-actions.component';
import { TabsComponent } from '../../../tabs/tabs.component';
import { TabComponent } from '../../../tabs/tab.component';
import { dateComparator } from '../../../data-table/comparators/data-table.comparators';
import { GridFormatterService } from '../../../../services/grid-formatter.service';
import { ChiefsOrderSearchSpec } from '../../../../../models/comodel/chiefs-order-search-spec.model';
import { ChiefsOrderInstance, ChiefsOrderStatus } from '../../../../../models/comodel/chiefsorderdetailsmodel.model';
import { ChiefsOrderService } from '../../../../../services/chiefsOrder.service';
import { LetterStatus } from '../../../../../letters/letters.model';
import { Router } from '@angular/router';

@Component({
    selector: 'organization-chiefs-orders',
    templateUrl: './organization-chiefs-orders.component.html',
    standalone: false
})
export class OrganizationChiefsOrdersComponent implements OnInit {

    @Input() organization: Organization;

    data: Observable<ChiefsOrderInstance[]>;

    gridOptions: GridOptions;
	gridApi?: GridApi;
    ngAfterViewInit() {
        if (this.gridApi != null) {
            this.gridApi.sizeColumnsToFit();
        }
    }

    constructor(@Host() public _tabs: TabsComponent,
                @Host() public _tab: TabComponent,
                public chiefsOrderService: ChiefsOrderService,
                public formatterService: GridFormatterService,
                private router: Router,
    ) {
    }
    ngOnInit() {
        this.gridOptions = this.formatterService.BuildDefaultGridOptionsWithColumns(this.createColumnDefs());
		this.gridOptions.onGridReady = (params) => { 
            this.gridApi = params.api; 
            this.gridApi.sizeColumnsToFit();
        };
        this._tabs.tabClicked.subscribe((result) => {
            if (result === this._tab && this.gridApi != null) {
                this.gridApi.sizeColumnsToFit();
            }
                
        });

        const spec = {
            statuses: [ChiefsOrderStatus.Issued, ChiefsOrderStatus.Appealed, ChiefsOrderStatus.Modified, ChiefsOrderStatus.Revoked, ChiefsOrderStatus.Suspended,
                        ChiefsOrderStatus.Terminated, ChiefsOrderStatus.Vacated],
            organizationIds: [this.organization.id, this.organization.historicalOwnerNumber ]
        } as ChiefsOrderSearchSpec;

        this.data = this.chiefsOrderService.getChiefsOrderInstances(spec);
    }
    dateFormatter(component: any, field: string) {
        return (obj) => component.datePipe.transform(obj.data[field], 'MM/dd/yyyy');
    }
    public createColumnDefs() {
        return [
            {
                headerName: 'Type of Order',
                headerTooltip: 'Type of Order',
                field: 'reportTemplateName',
                tooltipField: 'reportTemplateName',
                filter: "agTextColumnFilter",
                filterParams: this.formatterService.defaultTextFilterParams,
            },
                {
                headerName: "Chief's Order #",
                headerTooltip: "Chief's Order #",
                field: "chiefsOrderNumber",
                tooltipField: 'chiefsOrderNumber',
                filter: "agTextColumnFilter",
                filterParams: this.formatterService.defaultTextFilterParams,
                cellRenderer: RouterLinkRendererComponent,
                cellRendererParams: {
                    openInNewWindow: true,
                    textField: "chiefsOrderNumber",
                    url: (data: ChiefsOrderInstance) => {
                        return `${this.router.parseUrl(this.router.url).root}/admin/chief-orders/co-details/${data.id}`;
                    }
                },
                maxWidth: 150
            },
            {
                headerName: 'Issued Date',
                headerTooltip: 'Issued Date',
                field: 'lastUpdatedTime',
                tooltipValueGetter: this.formatterService.formatDate('lastUpdatedTime'),
                valueGetter: this.formatterService.formatDate('lastUpdatedTime'),
                comparator: dateComparator,
                filter: "agDateColumnFilter",
                filterParams: this.formatterService.defaultDateFilterParams,
                maxWidth: 120
            },
            {
                headerName: 'Status',
                headerTooltip: 'Status',
                field: 'status',
                tooltipField: 'status',
            },
            {
                headerName: 'Delivery Status',
                headerTooltip: 'Delivery Status',
                field: 'letterDeliveryStatus',
                tooltipField: 'letterDeliveryStatus',
                valueGetter: this.formatletterDeliveryStatus(),
                tooltipValueGetter: this.formatletterDeliveryStatus(),
            },
        ] as ColDef[]
    }

    public formatletterDeliveryStatus(): any {
        return (obj) => {
            switch ((obj.data as ChiefsOrderInstance).letterDeliveryStatus) {
                case LetterStatus.Delivered: {
                    return 'Delivered';
                }
                case LetterStatus.Pending: {
                    return 'Pending';
                }
                case LetterStatus.Returned: {
                    return 'Returned';
                }
                case LetterStatus.Sent: {
                    return 'Sent';
                }
                case LetterStatus.Unknown: {
                }
                default:
                    return 'Unknown';
            };
        }
    }
}
